export default "__VITE_ASSET__DquL7WBn__"